import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import PageTemplate from "../templates/PageTemplate";
import { db } from "../config/firebase";
import { useNavigate } from "react-router-dom";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

const collectionsToCount = [
  { key: "users", label: "Utilisateurs", path: "/users", icon: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" },
  { key: "projects", label: "Projets", path: "/projects", icon: "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" },
  { key: "offers", label: "Offres", path: "/offers", icon: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15a2.25 2.25 0 0 1 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25Z" },
  { key: "appointments", label: "Rendez-vous", path: "/rdv", icon: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" },
  { key: "categories", label: "Catégories", path: "/categories", icon: "M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z M6 6h.008v.008H6V6Z" },
  { key: "payments", label: "Paiements", path: "/payments", icon: "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" },
  { key: "reviews", label: "Avis", path: "/reviews", icon: "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" },
  { key: "reports", label: "Signalements", path: "/reports", icon: "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" },
];

const APPOINTMENT_STATUS = [
  { key: "pending", label: "En attente", color: "text-yellow-600" },
  { key: "confirmed", label: "Confirmé", color: "text-blue-600" },
  { key: "inProgress", label: "En cours", color: "text-indigo-600" },
  { key: "waitPayment", label: "Att. paiement", color: "text-orange-600" },
  { key: "paymentConfirmed", label: "Payé", color: "text-green-600" },
  { key: "refused", label: "Refusé", color: "text-red-600" },
  { key: "cancelled", label: "Annulé", color: "text-gray-600" },
];

const OFFER_STATUS = [
  { key: "pending", label: "En attente", color: "text-yellow-600" },
  { key: "confirmed", label: "Confirmée", color: "text-green-600" },
  { key: "refused", label: "Refusée", color: "text-red-600" },
];

const PROJECT_STATUS = [
  { key: "pending", label: "En attente", color: "text-yellow-600" },
  { key: "confirmed", label: "Confirmé", color: "text-blue-600" },
  { key: "waitPayment", label: "Att. paiement", color: "text-orange-600" },
  { key: "paymentConfirmed", label: "Payé", color: "text-green-600" },
];

const PIE_COLORS = ["#801111", "#E0BE71", "#6366f1", "#f59e0b", "#10b981", "#ef4444", "#6b7280"];

const MONTHS_FR = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];

export default function AdminHome() {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [verifiedUsers, setVerifiedUsers] = useState(0);
  const [clientsCount, setClientsCount] = useState(0);
  const [couturiersCount, setCouturiersCount] = useState(0);

  const [appointmentsByStatus, setAppointmentsByStatus] = useState({
    pending: 0, confirmed: 0, inProgress: 0, waitPayment: 0,
    paymentConfirmed: 0, refused: 0, cancelled: 0,
  });

  const [offersByStatus, setOffersByStatus] = useState({
    pending: 0, confirmed: 0, refused: 0,
  });

  const [projectsByStatus, setProjectsByStatus] = useState({
    pending: 0, confirmed: 0, waitPayment: 0, paymentConfirmed: 0,
  });

  const [registrationData, setRegistrationData] = useState([]);
  const [userTypeData, setUserTypeData] = useState([]);

  useEffect(() => {
    async function fetchCounts() {
      setLoading(true);
      const result = {};

      for (const c of collectionsToCount) {
        const snap = await getDocs(collection(db, c.key));
        result[c.key] = snap.size;

        if (c.key === "users") {
          const allUsers = snap.docs.map((d) => d.data());
          const verified = allUsers.filter((u) => !!u.emailIsVerified).length;
          const clients = allUsers.filter((u) => !!u.isClient).length;
          const couturiers = allUsers.filter((u) => !u.isClient).length;
          setVerifiedUsers(verified);
          setClientsCount(clients);
          setCouturiersCount(couturiers);

          // User type pie chart
          setUserTypeData([
            { name: "Clients", value: clients },
            { name: "Couturiers", value: couturiers },
          ]);

          // Registration trend (last 6 months)
          const now = new Date();
          const monthsData = [];
          for (let i = 5; i >= 0; i--) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            const month = d.getMonth();
            const year = d.getFullYear();
            const count = allUsers.filter((u) => {
              if (!u.createdAt) return false;
              const created = u.createdAt.toDate ? u.createdAt.toDate() : new Date(u.createdAt);
              return created.getMonth() === month && created.getFullYear() === year;
            }).length;
            monthsData.push({
              name: MONTHS_FR[month],
              inscriptions: count,
            });
          }
          setRegistrationData(monthsData);
        }

        if (c.key === "appointments") {
          const allAppointments = snap.docs.map((d) => d.data());
          const statusCount = {
            pending: 0, confirmed: 0, inProgress: 0, waitPayment: 0,
            paymentConfirmed: 0, refused: 0, cancelled: 0,
          };
          allAppointments.forEach((appt) => {
            if (statusCount[appt.status] !== undefined) statusCount[appt.status]++;
          });
          setAppointmentsByStatus(statusCount);
        }

        if (c.key === "offers") {
          const allOffers = snap.docs.map((d) => d.data());
          const statusCount = { pending: 0, confirmed: 0, refused: 0 };
          allOffers.forEach((offer) => {
            if (statusCount[offer.status] !== undefined) statusCount[offer.status]++;
          });
          setOffersByStatus(statusCount);
        }

        if (c.key === "projects") {
          const allProjects = snap.docs.map((d) => d.data());
          const statusCount = { pending: 0, confirmed: 0, waitPayment: 0, paymentConfirmed: 0 };
          allProjects.forEach((project) => {
            if (statusCount[project.status] !== undefined) statusCount[project.status]++;
          });
          setProjectsByStatus(statusCount);
        }
      }

      setCounts(result);
      setLoading(false);
    }

    fetchCounts();
  }, []);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-gray-200 rounded-lg px-3 py-2 shadow-sm">
          <p className="text-xs text-gray-500">{label}</p>
          <p className="text-sm font-semibold text-[#801111]">{payload[0].value} inscriptions</p>
        </div>
      );
    }
    return null;
  };

  return (
    <PageTemplate
      loading={loading}
      content={
        <div className="space-y-4">
          {/* Collection counts - clickable */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {collectionsToCount.map((c) => (
              <div
                key={c.key}
                onClick={() => navigate(c.path)}
                className="bg-white rounded-lg border border-gray-200 p-3 cursor-pointer hover:border-[#801111]/30 hover:shadow-sm transition-all group outline-none"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-[10px] text-gray-500 uppercase tracking-wide">{c.label}</p>
                    <p className="text-2xl font-semibold text-gray-900 mt-0.5">{counts[c.key] ?? "..."}</p>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-300 group-hover:text-[#801111] transition-colors">
                    <path strokeLinecap="round" strokeLinejoin="round" d={c.icon} />
                  </svg>
                </div>
              </div>
            ))}
          </div>

          {/* Charts row */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {/* Area chart - Inscriptions trend */}
            <div className="lg:col-span-2 bg-white rounded-lg border border-gray-200 p-4 [&_svg]:outline-none [&_*]:outline-none">
              <h3 className="text-sm font-semibold text-gray-900 mb-4">Inscriptions (6 derniers mois)</h3>
              <div className="h-52">
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={registrationData} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} allowDecimals={false} />
                    <Tooltip content={<CustomTooltip />} />
                    <Area
                      type="monotone"
                      dataKey="inscriptions"
                      stroke="#801111"
                      strokeWidth={2}
                      fill="#801111"
                      fillOpacity={0.08}
                      dot={{ r: 3, fill: "#801111", strokeWidth: 0 }}
                      activeDot={{ r: 5, fill: "#801111", strokeWidth: 2, stroke: "#fff" }}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Pie chart - User types */}
            <div className="bg-white rounded-lg border border-gray-200 p-4 [&_svg]:outline-none [&_*]:outline-none">
              <h3 className="text-sm font-semibold text-gray-900 mb-2">Répartition utilisateurs</h3>
              <div className="h-52">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={userTypeData}
                      cx="50%"
                      cy="45%"
                      innerRadius={45}
                      outerRadius={70}
                      paddingAngle={4}
                      dataKey="value"
                      strokeWidth={0}
                    >
                      {userTypeData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value, name) => [`${value} utilisateurs`, name]}
                      contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #e5e7eb" }}
                    />
                    <Legend
                      verticalAlign="bottom"
                      iconType="circle"
                      iconSize={8}
                      formatter={(value) => <span className="text-xs text-gray-600">{value}</span>}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* Detail panels - clickable */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Users breakdown */}
            <div
              onClick={() => navigate("/users")}
              className="bg-white rounded-lg border border-gray-200 p-4 cursor-pointer hover:border-[#801111]/30 hover:shadow-sm transition-all outline-none"
            >
              <h3 className="text-sm font-semibold text-gray-900 mb-3">Utilisateurs</h3>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Vérifiés</span>
                  <span className="font-medium text-gray-900">{verifiedUsers}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Clients</span>
                  <span className="font-medium text-gray-900">{clientsCount}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Couturiers</span>
                  <span className="font-medium text-gray-900">{couturiersCount}</span>
                </div>
              </div>
            </div>

            {/* Appointments breakdown */}
            <div
              onClick={() => navigate("/rdv")}
              className="bg-white rounded-lg border border-gray-200 p-4 cursor-pointer hover:border-[#801111]/30 hover:shadow-sm transition-all outline-none"
            >
              <h3 className="text-sm font-semibold text-gray-900 mb-3">Rendez-vous</h3>
              <div className="space-y-2">
                {APPOINTMENT_STATUS.map(({ key, label }) => (
                  <div key={key} className="flex justify-between text-sm">
                    <span className="text-gray-500">{label}</span>
                    <span className="font-medium text-gray-900">{appointmentsByStatus[key] ?? 0}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Offers breakdown */}
            <div
              onClick={() => navigate("/offers")}
              className="bg-white rounded-lg border border-gray-200 p-4 cursor-pointer hover:border-[#801111]/30 hover:shadow-sm transition-all outline-none"
            >
              <h3 className="text-sm font-semibold text-gray-900 mb-3">Offres</h3>
              <div className="space-y-2">
                {OFFER_STATUS.map(({ key, label }) => (
                  <div key={key} className="flex justify-between text-sm">
                    <span className="text-gray-500">{label}</span>
                    <span className="font-medium text-gray-900">{offersByStatus[key] ?? 0}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Projects breakdown */}
            <div
              onClick={() => navigate("/projects")}
              className="bg-white rounded-lg border border-gray-200 p-4 cursor-pointer hover:border-[#801111]/30 hover:shadow-sm transition-all outline-none"
            >
              <h3 className="text-sm font-semibold text-gray-900 mb-3">Projets</h3>
              <div className="space-y-2">
                {PROJECT_STATUS.map(({ key, label }) => (
                  <div key={key} className="flex justify-between text-sm">
                    <span className="text-gray-500">{label}</span>
                    <span className="font-medium text-gray-900">{projectsByStatus[key] ?? 0}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}
